define('lib/knockout-validation/initialize',['require','knockout','lib/knockout-validation/rules','knockout.validation'],function (require) {
    var ko = require('knockout');
    var validationRules = require('lib/knockout-validation/rules');

    require('knockout.validation');

    return function () {
        ko.validation.init({
            insertMessages: false,
            messagesOnModified: false,
            grouping: {
                deep: true,
                observable: true,
                live: true
            }
        });

        validationRules.register();
    };
});


